import { gql } from '@apollo/client';

export const GET_INSTITUTION = gql`
  query GetInstitution($institutionId: String!) {
    institutions(institutionIds: [$institutionId], take: 1) {
      institutionId
      institutionName
      city
      state
      isSubS
      institutionType
    }
  }
`;








